module.exports = require("@swa-ui/object");